import React from 'react'
// libs
import Tooltip from '@mui/material/Tooltip'
import { useMutation } from '@apollo/client/react'
// components
import { Button } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// views
import { EyeIcon, EyeSelectedIcon } from './views'
// themes
import { colors } from 'themes/index'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
import { LogicalConditionsContext } from 'containers/Risks/RiskTemplate/Edit/layers/LogicalConditions'
// types
import { IField, RiskTemplateFormConditionActionType } from 'types/graphql'
// graphql
import { FIELD_UPDATE_MUTATION } from 'graphql/objects/mutations'
// utils
import { handleError } from 'utils/errors/handlers'

interface Props {
  field: IField
}

const VisibilityButton: React.FC<Props> = ({ field }) => {
  const [updateField] = useMutation(FIELD_UPDATE_MUTATION)

  const { refetchTemplate } = React.useContext(RiskTemplateAPIContext)

  const { currentCondition, onFieldVisibilityChange } = React.useContext(LogicalConditionsContext)

  const fieldCondition = currentCondition?.actions?.find(
    (action) => action.fieldId === field.id && action.type === RiskTemplateFormConditionActionType.Visibility
  )

  const hidden = fieldCondition ? fieldCondition?.value : field.hidden

  const onVisibilityClick = async () => {
    if (currentCondition) {
      onFieldVisibilityChange?.(field.id, !fieldCondition?.value)
    } else {
      try {
        await updateField({
          variables: {
            id: field.id,
            input: {
              hidden: !field.hidden
            }
          }
        })

        refetchTemplate()
      } catch (e) {
        handleError(e, 'VisibilityButton.onVisibilityClick')
      }
    }
  }

  const isCurrentField = currentCondition?.fieldId === field.id

  return (
    <Tooltip title={hidden ? 'Show' : 'Hide'} placement='bottom'>
      <Button onClick={onVisibilityClick} disabled={isCurrentField}>
        {hidden ? (
          <EyeIcon color={fieldCondition ? colors.purple300 : colors.blue500} />
        ) : (
          <EyeSelectedIcon color={fieldCondition ? colors.purple300 : colors.blue500} />
        )}
      </Button>
    </Tooltip>
  )
}

export default VisibilityButton
